import React from 'react'
import PropTypes from 'prop-types'

import ActivityWrapupFlashcards from './ActivityWrapupFlashcards'
import ActivityWrapupReview from './ActivityWrapupReview'
import ActivityWrapupWriting from './ActivityWrapupWriting'
import ActivityWrapupConcept from './ActivityWrapupConcept'
import ActivityWrapupMedia from './ActivityWrapupMedia'
import ActivityWrapupActions from './subcomponents/ActivityWrapupActions/ActivityWrapupActions'
import WrapupCardStudyGoals from './subcomponents/WrapupCardStudyGoals/WrapupCardStudyGoals'
import WrapupCardLiveLesson from './subcomponents/WrapupCardLiveLesson/WrapupCardLiveLesson'
import WrapupCardPracticeWriting from './subcomponents/WrapupCardPracticeWriting/WrapupCardPracticeWriting'

const COMPONENTS_MAP = {
  flashcards: ActivityWrapupFlashcards,
  review: ActivityWrapupReview,
  writing: ActivityWrapupWriting,
  concept: ActivityWrapupConcept,
  video: ActivityWrapupMedia,
  audio: ActivityWrapupMedia,
  reading: ActivityWrapupMedia,
}

const ActivityWrapup = ({
  activityType,
  weeklyGoals,
  showLiveLessonSection,
  mediaThumbnailUrl,
  practiceWritingHref,
  ...rest
}) => {
  const Component = COMPONENTS_MAP[activityType]

  return Component ? (
    <Component
      activityType={activityType}
      liveLessonSection={
        showLiveLessonSection ? <WrapupCardLiveLesson /> : null
      }
      practiceWritingSection={
        practiceWritingHref ? (
          <WrapupCardPracticeWriting
            mediaThumbnailUrl={mediaThumbnailUrl}
            practiceWritingHref={practiceWritingHref}
          />
        ) : null
      }
      goalsSection={
        <WrapupCardStudyGoals
          weeklyGoals={weeklyGoals}
        />
      }
      actionsSection={<ActivityWrapupActions />}
      {...rest}
    />
  ) : null
}

ActivityWrapup.propTypes = {
  activityType: PropTypes.oneOf([
    'flashcards',
    'review',
    'reading',
    'writing',
    'video',
    'audio',
    'concept',
  ]).isRequired,
  weeklyGoals: PropTypes.object,
  showLiveLessonSection: PropTypes.bool,
  correctionsRequested: PropTypes.bool,
  correctionsUrl: PropTypes.string,
  mediaThumbnailUrl: PropTypes.string,
  practiceWritingHref: PropTypes.string,
  vocabularyGroups: PropTypes.arrayOf(PropTypes.object),
  subtitleSection: PropTypes.any,
  onActivityRated: PropTypes.func,
}

export default ActivityWrapup
